import React from 'react';

const OrderInfo = ({ id, dataLocale, billingAddress = {} }) => {
    const { firstName = '', lastName = '' } = billingAddress;
    const userName = `${firstName} ${lastName}`;
    const { ORDER, CUSTOMER_NAME } = dataLocale;
    return (
        <h3 className="margin-b0" style={{ color: '#cc0000', fontFamily: 'Rajdhani-Medium' }}>
            <span className="inline-block padding-r10">{ORDER} #{id}</span>
            <span className="inline-block capitalize">{CUSTOMER_NAME}: {userName}</span>
        </h3>
    );
};

export default OrderInfo;
